import { render, staticRenderFns } from "./TextAreaInput.vue?vue&type=template&id=765039a2&scoped=true"
import script from "./TextAreaInput.vue?vue&type=script&lang=js"
export * from "./TextAreaInput.vue?vue&type=script&lang=js"
import style0 from "./TextAreaInput.vue?vue&type=style&index=0&id=765039a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765039a2",
  null
  
)

export default component.exports